import React from 'react';
import './ResultModal.css';
import rightArrowImg from '../../icons/arrow-forward.svg';
import leftArrowImg from '../../icons/arrow-back.svg';

export default (props) => (
  <div className="overlay">
    <button className="closeModal" onClick={ () => props.setActiveResult(null) }>&times;</button>
    <div className="modalNav">
      <button
        className="directionButton leftArrow"
        onClick={ () => {
          let newIndex = 3;
          const resIndex = props.results.findIndex( (res) => {
            return res.fields.name === props.fields.name;
          })
          if(resIndex > 0) {
            newIndex = resIndex - 1;
          }
          props.setActiveResult(props.results[newIndex]);
        }}
      >
        <img src={leftArrowImg} alt="previous" />
      </button>
      <button
        className="directionButton rightArrow"
        onClick={ () => {
          let nextIndex = 0;
          const resIndex = props.results.findIndex( (res) => {
            return res.fields.name === props.fields.name;
          })
          if(resIndex < 3) {
            nextIndex = resIndex + 1;
          }
          props.setActiveResult(props.results[nextIndex]);
        }}
      >
        <img src={rightArrowImg} alt="next" />
      </button>
    </div>
    <div className="resultModal">
      <div className="resultModal--header">
        <div className="resultModal--img">
          <img src={props.fields.prodImgUrl} alt={props.fields.name} />
        </div>
        <div className="resultModal--meta">
          <h1 className="winnerTitle serif">{props.fields.name}</h1>
          <h4 className="fwn ttu">{props.fields.fragranceType}</h4>
          <div className="scentNotes">
            <div className="note">
              <h3 className="ttu">Head Notes</h3>
              <p>{props.fields.headNotes}</p>
            </div>
            <div className="note">
              <h3 className="ttu">Heart Notes</h3>
              <p>{props.fields.heartNotes}</p>
            </div>
            <div className="note baseNotes">
              <h3 className="ttu">Base Notes</h3>
              <p>{props.fields.baseNotes}</p>
            </div>
          </div>
          <p className="winnerDescription">{props.fields.blurb}</p>
          <footer className="winnerActions">
            { props.basket.filter(item => item.fields.name === props.fields.name).length ?
                <button 
                  className="button"
                  onClick={ () => props.removeFromBasket(props) }
                >
                  Remove
                </button>
              : props.basket.length < 2 ?
                <button 
                  className="button"
                  onClick={() => props.addToBasket(props)}
                >
                  Select
                </button>
              :
                <button 
                  className="button"
                  disabled
                >
                  Select
                </button>
              }
          </footer>
        </div>
      </div>
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/ResultModal/ResultModal.js